import { NgModule } from '@angular/core';
import {
  CybFooterComponent,
  CybFooterLeftDirective,
  CybFooterRightDirective,
  CybFooterContentDirective,
  CybFooterImageDirective
} from './footer.component';

@NgModule({
  declarations: [
    CybFooterComponent, CybFooterLeftDirective, CybFooterRightDirective, CybFooterContentDirective,
    CybFooterImageDirective
  ],
  exports: [
    CybFooterComponent, CybFooterLeftDirective, CybFooterRightDirective, CybFooterContentDirective,
    CybFooterImageDirective
  ]
})

export class CybFooterModule { }
